import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
export function Modal({
  isOpen,
  onClose,
  title,
  children
}: ModalProps) {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);
  return <AnimatePresence data-id="element-145">
      {isOpen && <div className="fixed inset-0 z-50 flex items-center justify-center p-4" data-id="element-146">
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} className="absolute inset-0 bg-navy/60 backdrop-blur-sm" onClick={onClose} data-id="element-147" />
          <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} transition={{
        duration: 0.3,
        ease: 'easeOut'
      }} className="relative bg-white rounded-2xl shadow-2xl w-full max-w-2xl max-h-[80vh] overflow-hidden" data-id="element-148">
            <div className="flex items-center justify-between p-6 border-b border-gray-100" data-id="element-149">
              <h2 className="text-2xl font-serif font-bold text-navy" data-id="element-150">
                {title}
              </h2>
              <button onClick={onClose} className="p-2 rounded-full hover:bg-cream transition-colors" aria-label="Cerrar" data-id="element-151">
                <XIcon className="w-5 h-5 text-charcoal" data-id="element-152" />
              </button>
            </div>
            <div className="p-6 overflow-y-auto max-h-[calc(80vh-80px)] text-charcoal text-body leading-relaxed space-y-4" data-id="element-153">
              {children}
            </div>
          </motion.div>
        </div>}
    </AnimatePresence>;
}